var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccupation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.2,
    height: 10.2,
    viewBox: "0 0 10.2 10.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icona_occupazione",
    "data-name": "icona occupazione",
    d: "M9.5,1.667H7.333V.926A.884.884,0,0,0,6.5,0h-3a.884.884,0,0,0-.833.926v.741H.5a.53.53,0,0,0-.5.556V6.344a.558.558,0,0,0,.333.523V9.444a.53.53,0,0,0,.5.556H9.167a.53.53,0,0,0,.5-.556V6.867A.558.558,0,0,0,10,6.344V2.222a.53.53,0,0,0-.5-.556ZM3,.926A.53.53,0,0,1,3.5.37h3A.53.53,0,0,1,7,.926v.741H6.667V.926A.177.177,0,0,0,6.5.741h-3a.177.177,0,0,0-.167.185v.741H3Zm3.333.741H3.667V1.111H6.333Zm3,7.778a.177.177,0,0,1-.167.185H.833a.177.177,0,0,1-.167-.185V6.931l3.667.562v.47a.53.53,0,0,0,.5.556h.333a.53.53,0,0,0,.5-.556v-.47l3.667-.562Zm-4-1.481a.177.177,0,0,1-.167.185H4.833a.177.177,0,0,1-.167-.185V6.852a.177.177,0,0,1,.167-.185h.333a.177.177,0,0,1,.167.185ZM9.667,6.344a.18.18,0,0,1-.143.184l-.046.007-3.81.584V6.852a.53.53,0,0,0-.5-.556H4.833a.53.53,0,0,0-.5.556v.267L.477,6.528a.18.18,0,0,1-.143-.184V2.222A.177.177,0,0,1,.5,2.037h9a.177.177,0,0,1,.167.185Zm0,0",
    transform: "translate(0.1 0.1)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupation);
export default __webpack_public_path__ + "static/media/occupation.664ee7dbc306e93a7abd2586fde2b387.svg";
export { ForwardRef as ReactComponent };